export var CANNOT_SAVE_CUSTOM_PROPS = "Impossibile salvare le proprietà";
export var CANNOT_SAVE_APP_SETTINGS = "Impossibile salvare le opzioni";
export var CANNOT_LOAD_CUSTOM_PROPS = "Impossibile caricare le proprietà";
export var EMAIL_ERROR_MESSAGES = "L'email non è stata inviata correttamente: %s (%s)";
export var EMAIL_SUCCESS_MESSAGES = "L'email inviata correttamente";
export var EMAIL_SENT_MESSAGES = "L'email è stata già inviata al CRM";

export function parse(str) {
  var args = [].slice.call(arguments, 1),
    i = 0;
  return str.replace(/%s/g, () => args[i++]);
}
